import { render, staticRenderFns } from "./classroomIntelligentBody.vue?vue&type=template&id=37c15a59&scoped=true"
import script from "./classroomIntelligentBody.vue?vue&type=script&lang=js"
export * from "./classroomIntelligentBody.vue?vue&type=script&lang=js"
import style0 from "./classroomIntelligentBody.vue?vue&type=style&index=0&id=37c15a59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c15a59",
  null
  
)

export default component.exports